<script setup>
import { ref, } from 'vue'
import { useUserStore } from '@/stores/user'
const store = useUserStore()
import { useRouter, useRoute } from 'vue-router'
const router = useRouter()
const route = useRoute()

let email = ref('');
let password = ref('');
let isSubmitting = ref(false);
let validated = ref(false)
let invalid = ref(false)

let failed = ref(false)
let message = ref('')

if (route.query.status == "validated") {
  validated.value = true
}
if (route.query.status == "invalid") {
  invalid.value = true
}


async function login() {
    isSubmitting.value = true

    validated.value = false
    invalid.value = false

    let result = await store.login(email.value, password.value)

    isSubmitting.value = false
    
    if(result.status) {
        email.value = "",
        password.value = ""
        router.push("/");        
    } else {
        failed.value = true
        message.value = result.message
    }
}
</script>

<template>
  <div class="login-container">
    <!--<h3 class="subheader mb-4">Make sense of the internet</h3>-->
      <div class="alert alert-success" v-if="validated" role="alert">
        Account validated! 
      </div>
      <div class="alert alert-warning" v-else-if="invalid" role="alert">
        Invalid key - please follow the link in the email
      </div>
      <div class="alert alert-danger" v-if="failed" role="alert">
        {{message}}
      </div>
      
      <div class="box bordered p-5">
        <h3 class="mb-4 jura text-center">Welcome back!</h3>
        <!--
        <div class="text-center mb-4">Don't have an account? &nbsp;<router-link to="/signup" class="link" style="color: white !important;">Sign up</router-link> </div>
        -->

        <form action="#" @submit.prevent="login()" class="form-floating mb-4">
            <div class="form-floating mb-3">
                <input type="email" v-model="email" class="form-control dark" id="floatingInput" placeholder="name@example.com">
                <label for="floatingInput">Email address</label>
            </div>
            <div class="form-floating mb-3">
                <input type="password" v-model="password" class="form-control dark" id="floatingPassword" placeholder="Password">
                <label for="floatingPassword">Password</label>
            </div>
            
            <button id="submit-btn" v-if="!isSubmitting" type="submit" class="btn btn-primary">Continue</button>
            <button id="submit-btn" v-else disabled type="submit" class="btn btn-primary">Logging in...</button>
        </form>

        <div class="text-center mb-4"><router-link to="/pw-reset-request" class="link" style="color: inherit;">Forgot password?</router-link></div>
      </div>
  </div>
</template>


<style scoped>
.login-container {
  width: 450px;
}

.wrapper {
    background-image: url('~@/assets/split-map.svg');
    background-repeat: no-repeat;
    background-position: 0;
    background-position-x: 100%;
    background-size: 55%;
}

.danger {
    color: #ffb0b0;
    font-size: 1rem;
}

#submit-btn {
    height: 64px;
    background-color: #2D3642;
    font-size: 1rem;
    outline:none;
    width: 100%;
    box-shadow: none;
    border:none;
    border-radius: 10px;
}

#submit-btn:hover {
    background-color: #36404F;
}

.link:hover {
  text-decoration: underline;
}
</style>
